import React from 'react';
import ButtonProps from '../../interfaces/ButtonProps'

const NextButton: React.FC<ButtonProps> = ({color, className, onClickFunc}) => {
  return (
    <button onClick={onClickFunc} className={className}/*disabled={currentIndex === items.length - 1}*/>
      <svg /*width="75" height="75"*/ viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.2441 31.74H43.2361M43.2361 31.74L33.1771 21.681M43.2361 31.74L33.1771 41.799" stroke={color || "#000"} strokeWidth="4.311" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M31.74 60.48C47.6125 60.48 60.48 47.6125 60.48 31.74C60.48 15.8673 47.6125 3 31.74 3C15.8673 3 3 15.8673 3 31.74C3 47.6125 15.8673 60.48 31.74 60.48Z" stroke={color || "#000"} strokeWidth="4.311" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  )
}

export default NextButton;